/**
 * NeilMed ADA Fixes for shop.neilmed.com
 * Runtime remediation for RAMP (axe-core) violations the theme won't let us fix at the source.
 *
 * Install
 *   1. Upload to theme Assets as nm-ada-fixes.js
 *   2. In theme.liquid, in <head> (no defer, no async)
 *      <script src="{{ 'nm-ada-fixes.js' | asset_url }}"></script>
 */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
   * Fix 1. aria-allowed-attr
   * FAQ toggles are <div class="ishi-collapse summary"> carrying
   * aria-expanded. A div with no role can't own that attribute.
   * Give them role="button", make them focusable, add key support
   * and keep aria-expanded in sync with .ishi-collapsed.
   * ------------------------------------------------------------- */
  function fixCollapseToggles(root) {
    (root || document).querySelectorAll('.ishi-collapse.summary[data-href]').forEach(function (el) {
      if (el.dataset.nmAda) return;
      el.dataset.nmAda = '1';

      if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
      syncExpanded(el);

      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          el.click();
        }
      });
    });
  }

  function syncExpanded(el) {
    el.setAttribute('aria-expanded', el.classList.contains('ishi-collapsed') ? 'false' : 'true');
  }

  /* ---------------------------------------------------------------
   * Fix 2. button-name
   * Owl Carousel pagination dots are empty <button class="owl-dot">.
   * Label each one "Go to slide N" and mark the active one.
   * ------------------------------------------------------------- */
  function fixOwlDots(root) {
    (root || document).querySelectorAll('.owl-dots').forEach(function (wrap) {
      wrap.querySelectorAll('.owl-dot').forEach(function (btn, i) {
        var label = 'Go to slide ' + (i + 1);
        if (btn.getAttribute('aria-label') !== label) btn.setAttribute('aria-label', label);
        btn.setAttribute('type', 'button');
        if (btn.classList.contains('active')) {
          btn.setAttribute('aria-current', 'true');
        } else {
          btn.removeAttribute('aria-current');
        }
      });
    });
  }

  /* ---------------------------------------------------------------
   * Fix 3. target-size (WCAG 2.5.8)
   * Owl dots are 18x12. Give the button a 24x24 hit area and spacing
   * while keeping the visible dot the same size.
   * ------------------------------------------------------------- */
  function injectStyles() {
    if (document.getElementById('nm-ada-styles')) return;
    var css = [
      '.owl-dots .owl-dot{',
      '  min-width:24px!important;min-height:24px!important;',
      '  padding:0!important;margin:0 4px!important;',
      '  display:inline-flex!important;align-items:center!important;justify-content:center!important;',
      '  background:transparent!important;border:0!important;',
      '}',
      '.owl-dots .owl-dot span{margin:0!important;}',
      '.fsb_msg_inner{text-shadow:1px 1px #000;}',
      '.smart-tabs-content-block a{text-decoration:underline;}',
      'body p{color:#666666;}',
      '.shopify-payment-button__button--unbranded{background-color:#00529C!important;color:#ffffff!important;}',
      '.shopify-payment-button__button--unbranded:hover,.shopify-payment-button__button--unbranded:focus{background-color:#003f78!important;color:#ffffff!important;}',
      '.shopify-payment-button__more-options{color:#00529C!important;text-decoration:underline;}'
    ].join('');
    var style = document.createElement('style');
    style.id = 'nm-ada-styles';
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  }

  /* ---------------------------------------------------------------
   * Fix 4. color-contrast
   * Inline color:#FF0000 fails AA on white (4.0:1). Swap to #E00000
   * (4.7:1). Catches hex, shorthand and rgb() forms.
   * ------------------------------------------------------------- */
  function fixInlineRed(root) {
    var sel = '[style*="ff0000" i],[style*="#f00" i],[style*="255, 0, 0"],[style*="255,0,0"],[color*="ff0000" i],[color*="#f00" i],[data-mce-style*="ff0000" i]';
    var isRed = function (v) {
      v = (v || '').replace(/\s/g, '').toLowerCase();
      return v === '#ff0000' || v === '#f00' || v === 'rgb(255,0,0)';
    };
    (root || document).querySelectorAll(sel).forEach(function (el) {
      if (isRed(el.style.color)) {
        el.style.setProperty('color', '#E00000', el.style.getPropertyPriority('color'));
      }
      if (el.hasAttribute('color') && isRed(el.getAttribute('color'))) {
        el.setAttribute('color', '#E00000');
      }
      if (el.hasAttribute('data-mce-style')) {
        el.setAttribute('data-mce-style', el.getAttribute('data-mce-style').replace(/#ff0000|#f00\b|rgb\(\s*255\s*,\s*0\s*,\s*0\s*\)/gi, '#E00000'));
      }
    });
  }

  /* ---------------------------------------------------------------
   * Fix 5. link-name
   * Header account icon link has no text. Label it.
   * ------------------------------------------------------------- */
  function fixAccountLink(root) {
    (root || document).querySelectorAll('a.userinfo-title').forEach(function (a) {
      if (!a.getAttribute('aria-label') && !a.textContent.trim()) {
        a.setAttribute('aria-label', 'My account');
      }
    });
  }

  /* ---------------------------------------------------------------
   * Fix 6. frame-title
   * Third party iframes (GTM, chat, payments, etc.) with no title.
   * Derive a name from the src host, fall back to a generic label.
   * ------------------------------------------------------------- */
  function fixIframeTitles(root) {
    (root || document).querySelectorAll('iframe:not([title]), frame:not([title])').forEach(function (f) {
      var title = 'Embedded content';
      var src = f.getAttribute('src') || '';
      try {
        var host = new URL(src, location.href).hostname.replace(/^www\./, '');
        if (host && host !== location.hostname) title = 'Embedded content from ' + host;
      } catch (e) {}
      if (/googletagmanager/i.test(src)) title = 'Google Tag Manager';
      f.setAttribute('title', title);
      if (f.offsetWidth === 0 && f.offsetHeight === 0) f.setAttribute('aria-hidden', 'true');
    });
  }

  /* ---------------------------------------------------------------
   * Boot and watch for re-renders (Owl refresh, AJAX sections, etc.)
   * ------------------------------------------------------------- */
  function runAll(root) {
    injectStyles();
    fixCollapseToggles(root);
    fixOwlDots(root);
    fixInlineRed(root);
    fixAccountLink(root);
    fixIframeTitles(root);
  }

  function init() {
    var scheduled = false;
    var observer = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === 'attributes' && m.target.classList && m.target.classList.contains('ishi-collapse')) {
          syncExpanded(m.target);
        }
      });
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        runAll();
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  var booted = false;
  function boot() {
    if (!booted && document.body) {
      booted = true;
      init();
    }
    runAll();
  }

  boot();
  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
  [250, 750, 1500, 3000, 6000].forEach(function (ms) { setTimeout(boot, ms); });
})();